export default __webpack_public_path__ + "static/zu1-ae08abffe6f0ba2aef08a6591084176b.png";